import { render } from "./activity.vue?vue&type=template&id=98723780&scoped=true&ts=true"
import script from "./activity.vue?vue&type=script&lang=ts&config=true"
export * from "./activity.vue?vue&type=script&lang=ts&config=true"

import "./activity.vue?vue&type=style&index=0&id=98723780&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98723780"]])

export default __exports__